import React, { useState } from 'react'


function footerForm() {
    // const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        // <div className="section-padding px-0 py-0">
        <div className="container   px-0  footerForm mb-5" style={{ minHeight: "fit-content", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div className="row  width75 px5rem justify-content-center  " style={{ backgroundColor: "rgb(205, 192, 139)", }}>
                <div className="w-100 px5rem py5rem">
                    <h2 className="text-left mb-4 fontFooterForm fontEb" style={{ fontWeight: "500", color: "#3a3a3a" }}>
                        Insights in your inbox
                    </h2>
                    <form className='d-flex flex-column gap-2 '>
                        <div className="row  ">
                            <div className="form-group col-md-6 width52">
                                <label htmlFor="firstName" style={{ fontWeight: "500", fontSize: "0.8rem", color: "#3a3a3a" }}>FIRST NAME</label>
                                <input type="text" className="form-control" id="firstName"  placeholder='Enter Your First Name ' style={{ borderRadius: "0", borderColor: "#3a3a3a" }} />
                            </div>
                            <div className="form-group col-md-6 width52">
                                <label htmlFor="lastName" style={{ fontWeight: "500", fontSize: "0.8rem", color: "#3a3a3a" }}>LAST NAME</label>
                                <input type="text" className="form-control" id="lastName" placeholder='Enter Your Last Name ' style={{ borderRadius: "0", borderColor: "#3a3a3a" }} />
                            </div>
                        </div>
                      
                        <div className="form-group ">
                            <label htmlFor="email" style={{ fontWeight: "500", fontSize: "0.8rem", color: "#3a3a3a" }}>EMAIL*</label>
                            <input type="email" className="form-control" id="email" placeholder='Enter Your Email' style={{ borderRadius: "0", borderColor: "#3a3a3a" }} />
                        </div>
                        <div className="form-group ">
                            <label htmlFor="jobTitle" style={{ fontWeight: "500", fontSize: "0.8rem", color: "#3a3a3a" }}>JOB TITLE</label>
                            <input type="text" className="form-control" id="jobTitle" placeholder='Job Title' style={{ borderRadius: "0", borderColor: "#3a3a3a" }} />
                        </div>
                      

                    
                        <div className="form-group ">
                            <label htmlFor="company" style={{ fontWeight: "500", fontSize: "0.8rem", color: "#3a3a3a" }}>COMPANY</label>
                            <input type="text" className="form-control" id="company" placeholder='Comapny' style={{ borderRadius: "0", borderColor: "#3a3a3a" }} />
                        </div>
                        <div className="form-group ">
                            <label htmlFor="linkedinUrl" style={{ fontWeight: "500", fontSize: "0.8rem", color: "#3a3a3a" }}>LINKEDIN URL</label>
                            <input type="text" className="form-control" id="linkedinUrl" placeholder='Linkdin Url' style={{ borderRadius: "0", borderColor: "#3a3a3a" }} />
                        </div>
                        
                        <div className="form-group form-check mt-3">
                            <input type="checkbox" className="form-check-input bg-transparent p-2 mr-1 " style={{ border: "1px solid #000", borderRadius: 0 }} id="optIn" />
                            <label className="form-check-label footercheckFont " htmlFor="optIn" style={{ color: "#3a3a3a", }}>
                                Opt in to receive future communications from Quantum. <span style={{ textDecoration: "none" }}>Privacy Policy*</span>.
                            </label>
                        </div>
                        <button type="submit" className="btn btn-danger my-4 w-fit align-self-end px-6 fontAva" style={{ backgroundColor: "#c82027", color: "#fff", borderRadius: "30px", padding: "10px 30px", fontWeight: "500", fontSize: "1rem" }}>
                            Submit
                        </button>
                    </form>
                </div>
            </div>
        </div>

        //  </div>


    )
}

export default footerForm;
